// src/components/auth/RegistrationCancel.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, HelpCircle, Mail } from 'lucide-react';
import './RegistrationCancel.css';

function RegistrationCancel() {
  const navigate = useNavigate();

  return (
    <div className="cancel-container">
      <div className="cancel-card">
        <div className="cancel-icon">
          <XCircle size={80} />
        </div>
        
        <h1>Registration Cancelled</h1>
        <p className="cancel-subtitle">
          You've cancelled the registration process. No charges have been made to your account.
        </p>

        <div className="cancel-reasons">
          <h2>Changed your mind?</h2>
          <p>Here are some common concerns we can help with:</p>
          
          <div className="reasons-grid">
            <div className="reason-item">
              <HelpCircle size={24} />
              <div>
                <h3>Not sure which plan?</h3>
                <p>Start with the Starter plan - you can upgrade anytime!</p>
              </div>
            </div>
            
            <div className="reason-item">
              <HelpCircle size={24} />
              <div>
                <h3>Need more information?</h3>
                <p>Check our FAQ or contact us for a demo</p>
              </div>
            </div>
            
            <div className="reason-item">
              <HelpCircle size={24} />
              <div>
                <h3>Budget concerns?</h3>
                <p>Remember: 14-day free trial, no credit card required!</p>
              </div>
            </div>
          </div>
        </div>

        <div className="cancel-benefits">
          <h2>Why Choose TaalumaERP?</h2>
          <ul>
            <li>✅ <strong>14-day free trial</strong> - Full access to all features</li>
            <li>✅ <strong>No credit card required</strong> - Try risk-free</li>
            <li>✅ <strong>Works offline</strong> - Perfect for areas with unreliable internet</li>
            <li>✅ <strong>Multi-currency support</strong> - USD, TZS, UGX</li>
            <li>✅ <strong>Easy setup</strong> - Get started in minutes</li>
            <li>✅ <strong>Cancel anytime</strong> - No long-term commitment</li>
          </ul>
        </div>

        <div className="action-buttons">
          <button onClick={() => navigate('/register')} className="btn-primary">
            <ArrowLeft size={20} />
            Try Again
          </button>
          <button onClick={() => navigate('/')} className="btn-secondary">
            Back to Home
          </button>
        </div>

        <div className="contact-support">
          <Mail size={20} />
          <div>
            <p>Have questions? <a href="mailto:support@taalumaerp.com">Contact our team</a></p>
            <small>We're here to help you find the right solution for your business</small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegistrationCancel;
